class TriggeredAlertEvent {
  constructor(
    duration,
    triggerTimestamp,
    acknowledgementTimestamp,
    acknowledgementUser,
  ) {
    this.duration = duration;
    this.triggerTimestamp = triggerTimestamp;
    this.acknowledgementTimestamp = acknowledgementTimestamp;
    this.acknowledgementUser = acknowledgementUser;
  }
}
export default TriggeredAlertEvent;
